export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? 'https://api.rroaded.co.uk',
  apiFileSizeLimit: 1000000,
  apiFileSizeLimitText: '1MB',
  facebookAppId: '1471515516756903',
  googleAppId: '462572476072-h6967vbd81epofirdresikm1qjl3q97c.apps.googleusercontent.com',
};
